import { Box, Button, Card, Divider, FormLabel, Table, Thead, Tbody, Tr, Th, Td, TableContainer, 
    HStack, CircularProgress, Spacer} from '@chakra-ui/react'
import 'moment/locale/es'
import { useTable, useSortBy, usePagination } from "react-table";
import useColumnsSales from "../hooks/useColumnsSales"
//import Sale from './Sale'
import { useEffect, useState, useRef } from 'react'
//import SalePayments from './SalePayments';
import SaleAdd from './SaleAdd';
import ReceiptAdd from './ReceiptAdd';
import CreditNoteAdd from './CreditNoteAdd';
//import PrintPDFNoOficial from './PrintPDFNoOficial';
import PrintPDFVoucher from './PrintPDFVoucher';
import InvoiceAdd from './InvoiceAdd';
import DespatchAdd from './DespatchAdd';
import { useNavigate } from "react-router-dom";
import authService from "../services/authService"
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
registerLocale('es', es)
const moment = require('moment')


const Sales = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [fromDate, setFromDate] = useState(new Date(moment().subtract(7, 'days')))
    const [toDate, setToDate] = useState(new Date())
    const [submitModal, setSubmitModal] = useState(false)

    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem("user")

        moment.locale("es")
        setLoading(true)

        const newFromDate = moment(fromDate).format('L')
        const newToDate = moment(toDate).format('L')
        
        const filter = {
            fromDate: newFromDate.split("/").reverse().join("-"),
            toDate: newToDate.split("/").reverse().join("-")
        }

        fetch("https://api.sistemacorralonbianchi.com.ar/api/sale/fromDate/" + filter.fromDate + "/toDate/" + filter.toDate, {
            headers: {
                'Content-Type': 'application/json',
                "x-auth-token": accessToken
            }
        })
        .then(response => response.json())
        .then(data => {
            const arrVouchers = data.map(voucher => {
                return {
                    id: voucher._id,
                    date: voucher.date,
                    dateFormat: moment(voucher.date).add(3,"h").format('L'),
                    customer: voucher.customer,
                    cuit: voucher.cuit,
                    voucherNumber: voucher.voucherNumber,
                    voucherLetter: voucher.voucherLetter,
                    price: "$" + parseFloat(voucher.price).toFixed(2),
                    isInvoice: voucher.isInvoice
                }
            })
            setData(arrVouchers)
            setLoading(false)
        })
        .catch(error => {
            authService.logout()
            navigate("/");
            window.location.reload();
        })    

    }, [fromDate, toDate, submitModal])

    const columns = useColumnsSales();
    const table = useTable({ columns, data, initialState: {pageSize: 30, pageIndex: 0, hiddenColumns: ["id", "date", "isInvoice"], sortBy: [{id: "date", desc: true}]} }, useSortBy, usePagination );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        prepareRow,
        state
    } = table

    const handleFromDate = (date) => {
        setFromDate(date || new Date())
    }

    const handleToDate = (date) => {
        setToDate(date || new Date())
    }

    const handleSubmitModal = () => {
        setSubmitModal(!submitModal)
    }

    return (
        <Box className="content" maxWidth="100%" overflow="hidden">
            <HStack marginBottom="10px">
                <SaleAdd handleSubmitModal={handleSubmitModal}/>
                <ReceiptAdd/>
                <DespatchAdd/>
                <CreditNoteAdd handleSubmitModal={handleSubmitModal}/>
            </HStack>

            <Card align="center" variant="elevated" padding="10px">
                    <HStack>
                    <Box></Box>
                        <FormLabel>Desde:</FormLabel>
                        <DatePicker locale='es' selected={fromDate} onChange={(date) => handleFromDate(date)} dateFormat="dd/MM/yyyy" />

                        <FormLabel>Hasta:</FormLabel>
                        <DatePicker locale='es' selected={toDate} onChange={(date) => handleToDate(date)} dateFormat="dd/MM/yyyy" />
                    </HStack>
            </Card>

            <Divider paddingTop="15px"/>

            {loading && <Box paddingTop="15px" textAlign='center'> 
                <CircularProgress isIndeterminate color='green.300' />
            </Box>}

            {!loading && <TableContainer paddingTop="15px">
                <Table variant='striped' size="sm" colorScheme='blackAlpha' {...getTableProps()}>
                    <Thead>
                        {
                            // Recorremos las columnas que previamente definimos
                            headerGroups.map(headerGroup => (
                                // Añadimos las propiedades al conjunto de columnas
                                <Tr {...headerGroup.getHeaderGroupProps()}>
                                {
                                    // Recorremos cada columna del conjunto para acceder a su información
                                    headerGroup.headers.map((column) => (
                                    // Añadimos las propiedades a cada celda de la cabecera
                                    <Th {...column.getHeaderProps(column.getSortByToggleProps())} >
                                        {
                                        // Pintamos el título de nuestra columna (propiedad "Header")
                                        column.render("Header")
                                        }
                                    </Th>
                                    ))
                                }
                                </Tr>
                            ))
                        }
                    </Thead>
                    <Tbody {...getTableBodyProps()}>
                        {
                            // Recorremos las filas
                            page.map(row => {
                                // Llamamos a la función que prepara la fila previo renderizado
                                prepareRow(row);
                                return (
                                // Añadimos las propiedades a la fila
                                <Tr {...row.getRowProps()}>
                                    {
                                    // Recorremos cada celda de la fila
                                    row.cells.map((cell) => {
                                        // Añadimos las propiedades a cada celda de la fila
                                        return (
                                        <Td  maxWidth="250px" overflow="hidden" textOverflow="ellipsis" {...cell.getCellProps()}>
                                            {
                                            // Pintamos el contenido de la celda
                                            cell.render("Cell")
                                            }
                                        </Td>
                                        );
                                    })
                                    }
                                    <Td>
                                        <HStack>
                                            {/*<Sale idSale={row.values.id}/>*/}
                                            {/*<SalePayments idSale={row.values.id} price={row.values.price} handleSubmitModal={handleSubmitModal}/>*/}
                                            {/*<PrintPDFNoOficial idSale={row.values.id}/>*/}
                                            <PrintPDFVoucher idVoucher={row.values.id} voucherLetter={row.values.voucherLetter}/>
                                            <InvoiceAdd idVoucher={row.values.id} cuit={row.values.cuit} isInvoice={row.values.isInvoice} handleSubmitModal={handleSubmitModal} voucherLetter={row.values.voucherLetter}/>
                                        </HStack>
                                    </Td>
                                </Tr>
                                );
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>}

            {!loading && <Box paddingTop="10px" textAlign="center">
                <Button marginRight="10px" colorScheme="facebook" onClick={() => previousPage()}>Anterior</Button>
                <Button colorScheme="facebook" onClick={() => nextPage()}>Siguiente</Button>
            </Box>}

        </Box>
    )

}

export default Sales